import facetFiltersForm from "../facets/facet-filters-form";
import facetRemove from "../facets/facet-remove";
import priceRange from "../facets/price-range";
import productCard from "../product/product-card";

export default (element) => {
  const closeFilters = element.querySelector('[data-close-filters]');
  const filterPanel = element.querySelector('side-panel');
  const applyFilters = element.querySelector('[data-apply-filters]');
  const filtersForm = element.querySelector('[data-facet-filters-form]');
  const clearfilters = element.querySelector('[data-clear-all]');
  let lastTriggerElement = null;
  
  facetFiltersForm();
  productCard();
  facetRemove();
  priceRange();

  // trigger side panel open from buttons
  document.querySelectorAll('[data-open-filters]').forEach((el) => {
    el.addEventListener('click', (e) => { 
      const { filter } = e.target.dataset;
      lastTriggerElement = e.target;
      closeFilters.setAttribute('tabindex',0);
      applyFilters.setAttribute('tabindex',0);
      filtersForm.classList.remove('hidden');
      if (clearfilters !== null) {
        clearfilters.setAttribute('tabindex',0)
      }
      // open the filter panel
      document.dispatchEvent(
        new CustomEvent(`open-panel:filter-panel`)
      );

      // open the filter panel
      document.dispatchEvent(
        new CustomEvent(`expand-filter:${filter}`)
      );

      closeFilters.focus();
      filterPanel.setAttribute('aria-modal','true');
    })
  });

  applyFilters.addEventListener('keydown',(e)=>{
    if(!e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      closeFilters.focus();
    }
  })
  
  closeFilters.addEventListener('keydown',(e)=>{
    if(e.shiftKey && e.key === 'Tab') {
      e.preventDefault();
      applyFilters.focus();
    }
  })

  document.querySelectorAll('[data-close-filters]').forEach((el) => {
    el.addEventListener('click', () => {
      // close the filter panel
      document.dispatchEvent(
        new CustomEvent(`close-panel:filter-panel`)
      );
      
      filterPanel.setAttribute('aria-modal','false');

      closeFilters.setAttribute('tabindex','-1');
      applyFilters.setAttribute('tabindex','-1');
      filtersForm.classList.add('hidden');
      if (clearfilters !== null) {
        clearfilters.setAttribute('tabindex','-1')
      }

      if (lastTriggerElement) {
        lastTriggerElement.focus();
      }

    })
  });
};
